import { render, staticRenderFns } from "./PayRedirect.vue?vue&type=template&id=c3969ed6&scoped=true&"
import script from "./PayRedirect.vue?vue&type=script&lang=js&"
export * from "./PayRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3969ed6",
  null
  
)

export default component.exports